/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/search-results';

export const SearchResultApi = {
  findRecentlySearchEntity: async (options: FindOptions) => {
    let url = `${pathname}/find-recently-search-entity`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (data: CreateSearchResultBody) => {
    const url = `${pathname}`;

    try {
      const response = await entityService.post(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateSearchResultBody {
  targetEntityID: string;
  partnerType: number;
  targetOwnerID: string;
}
